import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UserResponse } from "~types/user";
import { transformPermissionUserDetailsResponse } from "../utilities";

const useGetPermissionUser = () => {
  const request = useApi();
  const { organizationId, sport, userId } = useParams();

  return useQuery({
    queryKey: ["permission-users", sport, organizationId, userId],
    queryFn: () => request<UserResponse>(`${sport}/o/${organizationId}/users/${userId}`).then(transformPermissionUserDetailsResponse),
  });
};

export default useGetPermissionUser;
